// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkListStyles } from "@ces/Overrides/Widgets/Basic/LinkList";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color } from "@ces/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

linkListStyles.linkListWrapper = {
    css: css`
        text-transform: capitalize;
    `,
};
linkListStyles.titleWrapper = {
    css: css`
        margin-bottom: 12px;
    `,
};
linkListStyles.title = {
    size: 16,
    weight: fontConfig.weight.bold,
    as: "p",
    css: css`
        letter-spacing: 0;
        line-height: 19px;
    `,
};

linkListStyles.linkWrapper = {
    css: css`
        display: flex;
        gap: 14px;
        padding: 0;
        & .list-link {
            & ${TypographyStyle} {
                font-size: 12px;
                font-weight: ${fontConfig.weight.bold};
                letter-spacing: 0;
                line-height: 13px;
            }
        }
        &.horizontal {
            align-items: center;
            & .list-link {
                gap: 16px;
                &:not(:last-child) {
                    &:after {
                        content: "";
                        width: 1px;
                        height: 14px;
                        display: inline-block;
                        background: ${color("common.border")};
                    }
                }
            }
        }
        &.vertical {
            flex-direction: column;
        }
    `,
};
